import React from 'react'

import Icon from 'app/components/icons/icon/icon.component'
import NotesIconSVG from 'app/components/icons/notes-icon/notes-icon.svg'

type NotesIconProps = {
  width?: number | string
  height?: number | string
  className?: string
}

const NotesIcon = ({
  width = 'auto',
  height = 'auto',
  className,
}: NotesIconProps) => (
  <Icon
    className={className}
    src={NotesIconSVG}
    alt="Notes Icon"
    width={width}
    height={height}
    aria-hidden="true"
  />
)

export default NotesIcon
